import React from 'react';
import { DuplicatablePortList } from './DuplicatablePortList';

const MatcherPortTemplate = { name: 'Matcher for Case', type: { kind: 'generic', identifier: 'T' } };
const ValuePortTemplate = { name: 'Value for Case', type: { kind: 'generic', identifier: 'U' } };
const groupTemplate = [MatcherPortTemplate, ValuePortTemplate];

interface SwitchEditorProps {
    nodeState: Record<string, any>;
    setNodeState: (key: string, value: any) => void;
    nodeShape: {
        nodeInPorts: Array<{ name: string; type: any }>;
        nodeInstanceOutPorts: Array<{ name: string; type: any }>;
    };
    updateShape: (shape: { inPorts: Array<{ name: string; type: any }>; outPorts: Array<{ name: string; type: any }> }) => void;
}

export const SwitchEditor: React.FC<SwitchEditorProps> = props => {
    const [ports, setPorts] = React.useState<Array<{ name: string; type: any }>>([]);

    const handlePortsChange = (newPorts: Array<{ name: string; type: any }>) => {
        setPorts(newPorts);
    };

    return (
        <DuplicatablePortList
            groupName="Values"
            groupTemplate={groupTemplate}
            initialCopyCount={0}
            nodeState={props.nodeState}
            setNodeState={props.setNodeState}
            onPortsChange={handlePortsChange}
        />
    );
};
